export function getUserClassifierGroupNode(group, nodes) {
  var _group$source;

  if (group.type === 'DynamicBaseGroupNode') {
    return nodes.UserClassifierGroupNode[group.sourceGroupId] || null;
  } else if (group.type === 'DynamicGeneratedGroupNode' && (_group$source = group.source) !== null && _group$source !== void 0 && _group$source.id) {
    return nodes.UserClassifierGroupNode[group.source.id] || null;
  }

  return null;
}